// 服务管理列表
import { get, post } from './request'

// 服务管理-表格数据
function getServerTableList(params) {
  return get('/channel_admin/wxapp_service/service_info/list', params)
}
// 服务管理-咨询量 详情
function getConsultList(params) {
  return get('/channel_admin/wxapp_service/consult/list', params)
}
// 服务管理-访问次数 详情
function getVisitList(params) {
  return get('/channel_admin/wxapp_service/visit/list', params)
}

// 服务类型列表
function getServerTagList(params) {
  return get('/channel_admin/wxapp_service/service_type/list', params)
}

// 创建服务类型
function createServerTag(data) {
  return post('/channel_admin/wxapp_service/service_type/create', data)
}

// 删除服务类型
function deleteServerTag(data) {
  return post('/channel_admin/wxapp_service/service_type/delete', data)
}

// 更新服务类型
function updateServerTag(data) {
  return post('/channel_admin/wxapp_service/service_type/batch_update', data)
}

// 创建服务
function createServerInfo(data) {
  return post('/channel_admin/wxapp_service/service_info/create', data)
}

// 根据id获取服务详情
function getServerInfoDetail(data) {
  return get('/channel_admin/wxapp_service/service_info/detail', data)
}

// 服务可选专家列表
function getServerExpertList(data) {
  return get('/channel_admin/wxapp_service/expert/list', data)
}

// 根据id修改服务
function updateServerInfo(data) {
  return post('/channel_admin/wxapp_service/service_info/update', data)
}

// 服务报名列表
function getServerApplyList(data) {
  return get('/channel_admin/wxapp_service/service_info/form', data)
}

export {
  getServerTableList,
  getServerTagList,
  createServerTag,
  deleteServerTag,
  updateServerTag,
  createServerInfo,
  getServerExpertList,
  getServerInfoDetail,
  updateServerInfo,
  getConsultList,
  getVisitList,
  getServerApplyList,
}
